import { render, staticRenderFns } from "./ModulesComponent.vue?vue&type=template&id=413e213e&scoped=true"
import script from "./ModulesComponent.vue?vue&type=script&lang=js"
export * from "./ModulesComponent.vue?vue&type=script&lang=js"
import style0 from "./ModulesComponent.vue?vue&type=style&index=0&id=413e213e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e213e",
  null
  
)

export default component.exports